import { render, staticRenderFns } from "./CategorySwitcher.vue?vue&type=template&id=cf8deacc"
import script from "./CategorySwitcher.vue?vue&type=script&lang=js"
export * from "./CategorySwitcher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports